<template>
  <div class="container-otp">
    <div class="header">
      <PartnerLogo icon="otp/logo-otp"></PartnerLogo>
      <h4>Мини ДМС</h4>    
    </div>

    <div class="divider__top"></div>
    <div class="content">
      <section v-show="windowWidth >= 480 || mobileFormStep === 1" ref="parameters">
        <h2 class="title">Оформление</h2>
        <h3 class="subtitle">Параметры договора страхования</h3>
        <InputsContainer className="inputs-container__1" cols="5">
          <component :is="item.fieldType" v-for="(item, index) in parameters"
            class="inputs-container__field"
            :class="[0, 1, 3].includes(index) ? 'required-input' : '', item.error ? 'invalid-input' : ''"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
            @input="policyParametersInput($event, index)"
            @itemSelected="policyParametersSelected($event, index)"
          >
            <div v-if="index === 3"
              class="field__additional-info"
              :class="{'mobile': showAdditionalInfo}"
              @click.self="windowWidth <= 480 ? showAdditionalInfo = !showAdditionalInfo : null"
            >
              <img v-if="windowWidth >= 480 || !showAdditionalInfo" src="@/create/assets/icons/otp/info-otp.svg" @click="windowWidth <= 480 ? showAdditionalInfo = !showAdditionalInfo : null">
              <div v-if="windowWidth >= 480 || showAdditionalInfo">
                <div>
                  <h6>При стоимости полиса 2500 руб</h6>
                  <p>- Выплаты при получении травм в результате несчастного случая</p>
                  <p>- 1 дистанционная консультация ветеринара</p>
                  <p>- Дистанционные консультации дежурных врачей (терапевты/ педиатры)</p>
                  <p>- 5 дистанционных консультаций узких специалистов (20+ специализаций) по предварительной записи</p>
                  <p>- 2 дистанционных консультации психологов</p>
                </div>
                <div>
                  <h6>При стоимости полиса 5000 руб</h6>
                  <p>- Выплаты при получении травм в результате несчастного случая</p>
                  <p>- 2 дистанционные консультации ветеринара</p>
                  <p>- Дистанционные консультации дежурных врачей (терапевты/ педиатры)</p>
                  <p>- Дистанционные консультации узких специалистов (20+ специализаций) по предварительной записи</p>
                  <p>- Дистанционные консультации психологов</p>
                </div>
                <div>
                  <h6>При стоимости полиса 10000 руб</h6>
                  <p>- Выплаты при получении травм в результате несчастного случая</p>
                  <p>- 3 дистанционные консультации ветеринара</p>
                  <p>- Дистанционные консультации дежурных врачей (терапевты/ педиатры)</p>
                  <p>- Дистанционные консультации узких специалистов (20+ специализаций) по предварительной записи</p>
                  <p>- Дистанционные консультации психологов</p>
                  <p>- Медицинский ассистанс (подбор клиники, поиск необходимого врача)</p>
                  <p>- 1 очный прием врача</p>
                </div>
              </div>
            </div>
          </component>
        </InputsContainer>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 2" ref="insurer">
        <div class="divider__between-blocks"></div>
        <h2 class="title">Страхователь</h2>
        <h3 class="subtitle">Персональные данные</h3>
        <InputsContainer className="inputs-container__2" cols="5">
          <component :is="item.fieldType" v-for="(item, index) in insurer"
            class="inputs-container__field"
            :class="[0, 1, 3, 4, 5, 6, 7, 8].includes(index) ? 'required-input' : '', item.error ? 'invalid-input' : ''"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
            @input="policyInsurerInput($event, index)"
            @itemSelected="policyInsurerSelected($event, index)"
          />
        </InputsContainer>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 3" ref="documents">
        <div class="divider__between-blocks"></div>
        <h3 class="subtitle">Документы</h3>
        <InputsContainer className="inputs-container__3" cols="5">
          <component :is="item.fieldType" v-for="(item, index) in documents"
            class="inputs-container__field required-input"
            :class="item.error ? 'invalid-input' : ''"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
          />
        </InputsContainer>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 4" ref="addressReg">
        <div class="divider__between-blocks"></div>
        <h3 class="subtitle">Адрес места жительства (регистрации)</h3>
        <InputsContainer className="inputs-container__4" cols="5">
          <component :is="item.fieldType" v-for="(item, index) in address"
            class="inputs-container__field"
            :class="[1, 2, 3].includes(index) ? 'required-input' : '', item.error ? 'invalid-input' : ''"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
            @autoInput="inputEvent(item.validation, index, 'address')"
            @itemSelected="addressItemSelected($event, index, 'address')"
          />
        </InputsContainer>
      
        <Checkbox
          class="checkbox-landing"
          id="address"
          :checker="checkboxes"
          icon="check"
        >
          <p>Адрес фактического места жительства совпадает с адресом регистрации</p>
        </Checkbox>

        <template v-if="!checkboxes.address">
          <div class="divider__between-blocks"></div>
          <h3 class="subtitle" ref="addressReal">Адрес места жительства (фактический)</h3>
          <InputsContainer className="inputs-container__4" cols="5">
            <component :is="item.fieldType" v-for="(item, index) in addressReal"
              class="inputs-container__field"
              :class="[1, 2, 3].includes(index) ? 'required-input' : '', item.error ? 'invalid-input' : ''"
              :type="item.type"
              :items="item.items"
              v-model="item.value"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
              :title="item.title"
              :maskType="item.mask"
              :error="item.error"
              @autoInput="inputEvent(item.validation, index, 'addressReal')"
              @itemSelected="addressItemSelected($event, index, 'addressReal')"
            />
          </InputsContainer>
        </template>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 5">
        <div class="divider__between-blocks"></div>
        <h2 class="title">Застрахованный</h2>
        <Checkbox
          class="checkbox-landing"
          id="insurerIsInsured"
          :checker="checkboxes"
          icon="check"
          disabled
        >
          <p ref="insured">Застрахованный является страхователем</p>
        </Checkbox>

        <InputsContainer v-if="!checkboxes.insurerIsInsured" className="inputs-container__5" cols="5" >
          <component :is="item.fieldType" v-for="(item, index) in insured"
            class="inputs-container__field"
            :class="[0, 1, 3, 4, 6, 7, 8].includes(index) ? 'required-input' : '', item.error ? 'invalid-input' : ''"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
          />
        </InputsContainer>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 6" id="">
        <div class="divider__between-blocks"></div>
        <h2 class="title">Подтверждение данных</h2>
  
        <div class="shield">
          <img src="@/create/assets/icons/atb/shield-atb.svg" alt="">
          <p>Ваши данные не попадут третьим лицам. Мы соблюдаем закон о защите персональных данных</p>
        </div>
  
        <Confirmation
          class="confirmation-landing"
          checkboxClassName="checkbox-landing"
          :confirmationChecks="confirmationChecks"
          :links="links"
          :otp="true"
          icon="check"
        >
          После  завершения оплаты полис и комплект страховых документов будут направлены на указанный Вами адрес электронной почты.
        </Confirmation>
      </section>
  
      <div class="divider__between-blocks"></div>
      <div class="landing-form__steps">
        <button v-if="windowWidth <= 480"
          class="landing-form__back"
          :style="mobileFormStep === 1 ? {opacity: 0, pointerEvents: 'none'} : {}"
          @click="mobileFormStep--"
        >
          <img class="makc__logo" src="@/create/assets/icons/atb/arrow-back-atb.svg">
        </button>
        <button v-if="windowWidth <= 480 && mobileFormStep < 6"
          class="landing-form__confirm landing-form__next"
          @click="validateAndMoveNext"
        >
          Далее
        </button>
        <button v-if="windowWidth >= 480 || mobileFormStep === 6"
          type="submit" class="landing-form__confirm last-button"
          @click="checkConfirmAndPay"
          :disabled="creatingPaymentCheckStatus"
        >
          {{ creatingPaymentCheckStatus ? 'Формируем счет...' : 'Перейти к оплате' }}
          <img v-if="creatingPaymentCheckStatus" class="makc-alert__loading-img" src="@/create/assets/images/loading.png" alt="loading">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MakcLogo from '@/create/components/landingsConstructor/MakcLogo.vue';
import PartnerLogo from '@/create/components/landingsConstructor/PartnerLogo.vue';
import InputsContainer from '@/create/components/landingsConstructor/InputsContainer.vue';
import Input from '@/create/components/landingsConstructor/Input.vue';
import Select from '@/create/components/landingsConstructor/Select.vue';
import Autocomplete from '@/create/components/landingsConstructor/Autocomplete.vue';
import Checkbox from '@/create/components/landingsConstructor/Checkbox.vue';
import Confirmation from '@/create/components/landingsConstructor/Confirmation.vue';
import { defaultParameters2, defaultInsurer, defaultDocuments, defaultAddress } from '@/create/components/landingsConstructor/dataFields';
import { validateFields } from '@/create/components/landingsConstructor/landingValidators';
import { checkJWT, getKidPolicyCreateContract, getKladr, getPayLink } from '@/create/components/landingsConstructor/landingFunctions';
import { localDevelopment, subdomain, testDevelopment } from '@/create/composables/const';

  export default {
    components: {
      MakcLogo,
      PartnerLogo,
      InputsContainer,
      Input,
      Select,
      Autocomplete,
      Checkbox,
      Confirmation,
    },
    data() {
      return {
        parameters: structuredClone(defaultParameters2),
        insurer: structuredClone(defaultInsurer),
        documents: structuredClone(defaultDocuments),
        address: structuredClone(defaultAddress),
        addressReal: structuredClone(defaultAddress),
        insured: structuredClone(defaultInsurer),

        checkboxes: {
          address: true,
          insurerIsInsured: true,
        },
        confirmationChecks: {
          usa: false,
          person: false,
          nalog: false,
          politics: false,
          kid: false,
          policy: false,
        },
        links: {
          politics: 'https://makclife.ru/upload/medialibrary/2b2/PolitikaPD.pdf',
          kid: '',
          policy: '',
          rules: 'https://makclife.ru/b2b/life/rules/otp/rule_9_08.pdf',
        },

        mobileFormStep: 1,                         // это если используется пошаговая форма
        showAdditionalInfo: false,                 // это подсказка по стоимости полиса

        requestLogin: 'sysclientotp',              // логин для запросов по конкретному лендингу, устанавливается в б2б контрагентах и копируется в makc-ins-site > app > create > app.php
        domain: localDevelopment || testDevelopment ? `https://${subdomain}.makclife.ru` : "https://makclife.ru",
        timeoutKidPolicy: null,                    // дебаунс кида
        creatingPaymentCheckStatus: false          // дизабл кнопки формирования счета
      }
    },
    computed: {
      windowWidth() {
        return window.innerWidth
      },
      structuredDataForApi() {                     // структурируем дату для передачи в контракт
        const contactsData = this.checkboxes.insurerIsInsured ? structuredClone([this.insurer]) : structuredClone([this.insurer, this.insured])
        const documentsData = this.checkboxes.insurerIsInsured ? structuredClone([this.documents]) : structuredClone([this.documents, this.documents])
        const addressData = this.checkboxes.address ? structuredClone([this.address, this.address]) : structuredClone([this.address, this.addressReal])
        
        return {
          agreement: {
            program: 'mini_dms',
            ins_calc_amount: (this.parameters[3].value * 10).toString(),
            ins_period: '1Y',
            insured: this.checkboxes.insurerIsInsured ? 0 : 1,
            insurer_sex: '0',
            status: 10,
          },
          contacts: contactsData,
          documents: documentsData,
          addresses: addressData
        }
      }
    },
    methods: {
      // ----------------- методы для обработки полей формы
      policyParametersInput(value, index) {                 // отслеживание инпутов в параметрах договора
        if (index === 0) {
          this.insurer[3].value = value
        }
      },
      policyParametersSelected(item, index) {               // отслеживание селектов в параметрах договора
        if (index === 1) {
          this.insurer[4].value = item
        }
        if (index === 3) {
          this.parameters[4].value = `${(item * 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ₽`
        }
      },
      policyInsurerInput(value, index) {                    // отслеживание инпутов в страхователе
        if (index === 3) {
          this.parameters[0].value = value
        }
      },
      policyInsurerSelected(item, index) {                  // отслеживание селектов в страхователе
        if (index === 4) {
          this.parameters[1].value = item
        }
      },
      async inputEvent(field, index, tag) {                 // поиск города и улицы по кладру
        if (field === 'city' && this[tag][index].value.length > 1) {
          this[tag][index].key = ''
          this[tag][index].items = await getKladr(this.requestLogin, this[tag][index].value, 'city')
        } else
        if (field === 'street' && this[tag][index].value.length > 1 && this[tag][index-1].key) {
          this[tag][index].key = ''
          this[tag][index].items = await getKladr(this.requestLogin, this[tag][index].value, 'street', this[tag][index-1].key)
        }
      },
      addressItemSelected(item, index, tag) {               // устанавливаем код города и улицы
        this[tag][index].key = item.id
      },
      async validateAndMoveNext() {                    // валидация на каждом шаге в мобильной версии
        let validationResult = false;
        
        switch(this.mobileFormStep) {
          case 1:  // Параметры договора
            validationResult = validateFields(this.parameters);
            if (validationResult) {
              this.$refs.parameters.scrollIntoView();
            }
            break;
          case 2:  // Страхователь
            validationResult = validateFields(this.insurer);
            if (validationResult) {
              this.$refs.insurer.scrollIntoView();
            }
            break;
          case 3:  // Документы
            validationResult = validateFields(this.documents, {birthDate: this.parameters[0].value});
            if (validationResult) {
              this.$refs.documents.scrollIntoView();
            }
            break;
          case 4:  // Адрес регистрации и фактический
            validationResult = validateFields(this.address);
            if (validationResult) {
              this.$refs.addressReg.scrollIntoView();
            }
            if (!this.checkboxes.address && !validationResult) {
              validationResult = validateFields(this.addressReal);
              if (validationResult) {
                this.$refs.addressReal.scrollIntoView();
              }
            }
            break;
          case 5:  // Застрахованный
            if (!this.checkboxes.insurerIsInsured) {
              validationResult = validateFields(this.insured);
              if (validationResult) {
                this.$refs.insured.scrollIntoView();
              }
            }
            break;
        }
        
        // Если прошли валидацию на текущем шаге, переходим к следующему
        if (!validationResult) {
          this.mobileFormStep++;
        }
      },
      // ----------------------------------------------------- методы апи
      async watchFieldsAndGetLinksForDocuments() {          // получение ссылок на документы
        if (this.timeoutKidPolicy) {
            clearTimeout(this.timeoutKidPolicy);
        }

        this.timeoutKidPolicy = setTimeout(async () => {
          const res = await getKidPolicyCreateContract(this.requestLogin, 'get_kid', this.structuredDataForApi);
          if (res && res.state === 'success') {
            this.links.kid = this.domain + res.kid
            this.links.policy = this.domain + res.project
          }
        }, 2500);
      },
      async checkConfirmAndPay() {
        let validationResult = 0                            // сначала валидируем блоки с полями
                                                            // не всегда везде нужна валидация, поэтому разделено
        for (const key in this.confirmationChecks) {
          if (this.confirmationChecks[key] === false) {
            validationResult++
          }
        }
        
        // Для десктопной версии выполняем полную валидацию всех полей
        // Для мобильной версии проверяем только подтверждения, т.к. поля уже были проверены
        if (this.windowWidth >= 480) {
          if (!this.checkboxes.insurerIsInsured) {
            if (validateFields(this.insured)) {
              this.$refs.insured.scrollIntoView();
              validationResult++
            }
          }
          if (!this.checkboxes.address) {
            if (validateFields(this.addressReal)) {
              this.$refs.addressReal.scrollIntoView();
              validationResult++
            }
          }
          if (validateFields(this.address)) {
            this.$refs.addressReg.scrollIntoView();
            validationResult++
          }
          if (validateFields(this.documents, {birthDate: this.parameters[0].value})) {
            this.$refs.documents.scrollIntoView();
            validationResult++
          }
          if (validateFields(this.insurer)) {
            this.$refs.insurer.scrollIntoView();
            validationResult++
          }
          if (validateFields(this.parameters)) {
            this.$refs.parameters.scrollIntoView();
            validationResult++
          }
        } else {
          // Для мобильной версии проверяем только подтверждения на последнем шаге
          if (validationResult > 0) {
            // Пролистываем к первому невыбранному чекбоксу
            this.$el.querySelector('input[type="checkbox"]:not(:checked)').scrollIntoView();
          }
        }

        if (validationResult < 1) {                         // если ни в одном блоке ошибок нет, создаем контракт
          this.creatingPaymentCheckStatus = true
          const res = await getKidPolicyCreateContract(this.requestLogin, 'create', this.structuredDataForApi);
          if (res && res.state === 'success') {
            const data = {
              contractId: res.id,
              phone: this.insurer[7].value.match(/([0-9]|[+])/g).join(''),
              email: this.insurer[8].value
            }
            await getPayLink(this.requestLogin, data)       // создаем ссылку на оплату
          }
          this.creatingPaymentCheckStatus = false
        }
      },
    },
    async mounted() {
      // let res = await checkJWT(this.requestLogin, this.$route.params.id)
      this.$watch(vm => [vm.parameters, vm.insurer, vm.documents, vm.address, vm.addressReal, vm.insured, vm.checkboxes.insurerIsInsured], () => {          // отслеживаем форму и производим калькуляцию
        this.watchFieldsAndGetLinksForDocuments()
      }, {
        immediate: true,
        deep: true
      })

      window.document.head.getElementsByTagName('title')[0].innerHTML = 'Мини ДМС'
    }
  }
</script>

<style lang="scss" scoped>
// -------------------- шрифты для этого лендинга

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100..900&display=swap');

// -------------------- стили этого лендинга
.container-otp {                    // контейнер
  max-width: 1320px;
  margin: 0 auto;
  width: calc(100vw - 40px);
  font-family: "Montserrat", sans-serif;
}

.divider {                          // разделители между разными блоками и подблоками
  &__top {
    margin-top: 120px;
  }

  &__between-blocks {
    margin-top: 70px;
  }
}

.header {                           // шапка с логотипами
  margin-top: 60px;
  h4 {
    margin-top: 8px;
    padding-left: 65px;
    font-family: Montserrat;
    font-weight: 400;
    font-size: 24px;
  }
}

.title {                            // заголовок большой (Оформление, Страхователь, Застрахованный...)
  font-weight: 700;
  font-size: 34px;
  line-height: normal;
  color: #555854;
  font-family: "Montserrat", sans-serif;
}

.subtitle {                         // подзаголовок (Параметры договора страхования, Персональные данные, Документы)
  margin-top: 4px;
  font-weight: 400;
  font-size: 22px;
  line-height: normal;
  color: #555854;
  font-family: "Montserrat", sans-serif;
}

.inputs-container {                 // грид контейнер - здесь расположение, отступы вложенных элементов
  &__1 {                            // 1 контейнер с параметрами
    margin-top: 40px;
    gap: 20px;
  }

  &__2 {                            // 2 контейнер с персональными данными
    margin-top: 40px;
    gap: 20px;

    .inputs-container__field:nth-child(4),
    .inputs-container__field:nth-child(5) {
      display: none;
    }

    .inputs-container__field:nth-child(9) {
      grid-column: span 2;
    }
  }

  &__3 {                            // 3 контейнер с документами
    margin-top: 30px;
    gap: 20px;

    .inputs-container__field:nth-child(6) {
      grid-column: span 3;
    }
  }

  &__4 {                            // 4 контейнер с адресом
    margin-top: 30px;
    gap: 20px;
  }

  &__5 {                            // 5 контейнер с выгодоприобретателями
    margin-top: 30px;
    gap: 20px;

    .inputs-container__field:nth-child(9) {
      grid-column: span 2;
    }
  }

  &__field {                        // верстка каждого инпута и его содержимого
    :deep(p) {                      // метка над инпутом
      font-weight: 400;
      font-size: 15px;
      color: #6E6E6E;
      margin-bottom: 6px;
    }

    :deep(input),                   // внешний вид инпутов
    :deep(select) {
      border: 1px solid #E3E3E3;
      border-radius: 10px;
      padding: 10px 20px;
      max-height: 52px;
      font-weight: 400;
      font-size: 1rem;
      line-height: 31px;
      color: #6E6E6E;
      outline: none;
      font-family: "Montserrat", sans-serif;

      &::placeholder {
        color: #C8C8C8;
      }
    }

    :deep(select) {                 // внешний вид селектов
      background: url('@/create/assets/icons/atb/arrow-down-atb.svg') no-repeat 92% 50%;
      color: #C8C8C8;
    }
    
    :deep(select:valid) {
      color: #6E6E6E;
    }

    :deep(option) {                 // внешний вид опций селекта
      color: #6E6E6E;
    }

    :deep(.autocomplete__items) {   // внешний вид автокомплита для адресов
      background-color: white;
      max-height: 115px;

      div {
        color: #6E6E6E;
        padding-left: 4px;

        &:hover {
          background-color: black;
          color: white;
        }
      }
    }

    :deep(span) {                   // ошибки валидации под инпутами 
      margin-top: 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #F47332;
    }
  }
}

.required-input {                   // звездочки над обязательными полями
  :deep(p::before) {
    content: '*';
    position: relative;
    color: #F47332;
  }
}

.invalid-input {
  :deep(input),
  :deep(select) {
    border-color: #F47332;
  }
}

.field__additional-info {           // иконка с дополнительной инфой
  z-index: 1;
  img {
    position: absolute;
    top: -15px;
    left: 155px;
    cursor: pointer;
  }

  > div {
    display: none;
    position: absolute;
    width: 494px;
    top: 5px;
    left: 175px;
    border-radius: 20px;
    padding: 20px 40px;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px 0px #00000040;
    flex-direction: column;
    gap: 40px;

    @media (max-width: 1780px) {
      left: 22px;
    }
  }

  img:hover ~ div {
    display: flex;
  }

  h6 {
    margin: 0 0 4px 0;
    font-weight: 400;
    font-size: 22px;
    line-height: normal;
    color: #555854;
  }

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: normal;
    color: #555854;
    margin: 0;
  }
  p::before {
    display: none;
  }
}

.checkbox-landing {                 // чекбоксы (адрес, наследники...)
  margin-top: 20px;

  :deep(label) {
    gap: 8px;
  }

  :deep(span) {
    width: 20px;
    height: 20px;
    padding: 4px;
    border-radius: 5px;
    border: 1px solid #F47332;
  }

  :deep(input:checked + label > span) {
    background-color: #C1FF05;
    border-color: #C1FF05;
  }
  
  :deep(p) {
    font-weight: 400;
    font-size: 15px;
    color: #6E6E6E;
  }

  :deep(input:disabled + label > span) {
    background-color: #6E6E6E;
    border-color: #6E6E6E;
  }
}

.plus-minus {                       // кнопки добавить, удалить выгодоприобретателя
  margin-top: 20px;
  display: flex;
  gap: 10px;

  span {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #E3E3E3;
    border-radius: 50%;
    font-size: 1.5rem;
    cursor: pointer;
  }
}

.shield {                           // титул блока о защите данных
  margin-top: 30px;
  width: max-content;
  display: flex;
  gap: 10px;
  align-items: center;
  border: 1px solid #14BB33;
  border-radius: 50px;
  padding: 13px 28px;

  p {
    font-weight: 400;
    font-size: 16px;
    color: #14BB33;
  }

}

.confirmation-landing {             // блок с подтверждениями, согласием и документами
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  :deep(p) {
    font-weight: 400;
    font-size: 15px;
    color: #6E6E6E;
  }

  :deep(>p:not(:last-child)) {
    margin-left: 30px;
  }

  :deep(a) {
    color: #2F5ADA;
    text-decoration: none;
  }

  :deep(.checkbox-landing) {        // чекбоксы (кид, полис, правила...)
    label {
      gap: 8px;
    }

    span {
      width: 20px;
      height: 20px;
      padding: 4px;
      border-radius: 5px;
      border: 1px solid #F47332;
    }

    input:checked + label > span {
      background-color: #C1FF05;
      border-color: #C1FF05;
    }
  }
}

.landing-form {
  &__steps {
    margin-bottom: 20px;
  }
  
  &__confirm {            // кнопка подтвердить данные и перейти к оплате
    border-radius: 50px;
    border: none;
    padding: 0 36px;
    height: 54px;
    background-color: #C1FF05;
    font-weight: 500;
    font-size: 1rem;
    color: #242424;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: Montserrat;

    img {
      margin-left: 10px;
      max-height: 50%;
    }
  }
}


// ------------------------ мобильная верстка ------------------------

@media (max-width: 480px) {
  .divider {                          // разделители между разными блоками и подблоками
    &__top {
      margin-top: 40px;
    }

    &__between-blocks {
      margin-top: 40px;
    }
  }

  .header {                           // шапка с логотипами
    margin-top: 40px;

    h4 {
      margin-top: 0;
      padding-left: 35px;
      font-size: 12px;
    }
    
    :deep(.partner__logo) {
      width: 142px;
    }
  }

  .title {                            // заголовок большой (Оформление, Страхователь, Застрахованный...)
    font-size: 24px;
  }

  .subtitle {                         // подзаголовок (Параметры договора страхования, Персональные данные, Документы)
    font-size: 16px;
  }

  .inputs-container {                 // грид контейнер - здесь расположение, отступы вложенных элементов
    &__1 {                            // 1 контейнер с параметрами
      margin-top: 30px;

      .inputs-container__field:nth-child(-n+5) {
        grid-column: span 5;
      }
    }

    &__2 {                            // 2 контейнер с персональными данными
      margin-top: 30px;
      
      .inputs-container__field:nth-child(-n+9) {
        grid-column: span 5;
      }
    }

    &__3 {                            // 3 контейнер с документами
      .inputs-container__field:nth-child(-n+6) {
        grid-column: span 5;
      }
    }

    &__4 {                            // 4 контейнер с адресом
      .inputs-container__field:nth-child(-n+7) {
        grid-column: span 5;
      }
    }

    &__5 {                            // 5 контейнер с выгодоприобретателями

      .inputs-container__field:nth-child(-n+7) {
        grid-column: span 5;
      }
    }

    &__field {                        // верстка каждого инпута и его содержимого
      :deep(p) {                      // метка над инпутом
        font-size: 13px;
      }

      :deep(input),                   // внешний вид инпутов
      :deep(select) {
        border-radius: 6px;
        padding: 12px 14px;
        max-height: 44px;
        font-size: 14px;
        line-height: 16px;
      }

      :deep(select) {                 // внешний вид селектов
        background: url('@/create/assets/icons/atb/arrow-down-atb.svg') no-repeat 95% 50%;
      }

      :deep(span) {                   // ошибки валидации под инпутами 
        font-size: 12px;
        line-height: 14px;
      }
    }
  }

  .checkbox-landing {                 // чекбоксы (адрес, наследники...)
    :deep(label) {
      gap: 10px;
    }

    :deep(span) {
      align-self: start;
      min-width: 20px;
    }
    
    :deep(p) {
      font-size: 12px;
      line-height: 14px;
    }
  }

  .shield {                           // титул блока о защите данных
    width: auto;
    padding: 14px;

    p {
      font-size: 12px;
      line-height: 14px;
    }

  }

  .confirmation-landing {             // блок с подтверждениями, согласием и документами
    gap: 10px;

    :deep(p) {
      font-size: 12px;
      line-height: 14px;
    }

    :deep(>p:not(:last-child)) {
      margin-left: 30px;
    }

    :deep(.checkbox-landing) {        // чекбоксы (кид, полис, правила...)
      span {
        min-width: 20px;
        align-self: start;
      }
    }
  }

  .landing-form {
    &__steps {
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }

    &__back {
      padding: 12px 26px;
      font-weight: 500;
      border-radius: 50px;
      border: none;
      background-color: #C8C8C8;
      cursor: pointer;
    }

    &__next {
      width: 146px;
    }
    
    &__confirm {             // кнопка подтвердить данные и перейти к оплате
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      padding: 0 20px;
      max-width: calc(100% - 80px);

      &.last-button {
        flex-grow: 1;
      }
    }
  }

  .field__additional-info {           // иконка с дополнительной инфой
    &.mobile {
      position: fixed;
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgb(0,0,0,0.2);
    }

    img {
      top: 0px;
      left: auto;
      right: 0;
    }

    > div {
      display: flex;
      position: relative;
      width: calc(100vw - 40px);
      top: 0;
      left: 0;
      padding: 20px;

    }

    h6 {
      font-size: 16px;
    }

    p {
      font-size: 8px;
    }
  }
}
</style>